import React, { useContext } from 'react';
import AlertDialog from 'ls-common-client/dist/components/AlertDialog';
import { Context } from '../../../context/AppContext';
import { logout } from '../../../services/authService';
import { MODALS } from '../../../constants';

const LogoutModal = () => {
  const {
    modal: { hideModal, modals },
  } = useContext(Context);
  const modalName = MODALS.USER_LOGOUT;

  const { show } = modals[modalName] || {};

  return (
    <AlertDialog
      zIndex="999999"
      animationDuration={200}
      show={show}
      heading="Are you sure you want to log out?"
      text="Logging out will mean you lose your user only features."
      clickOutside
      onClose={() => hideModal(modalName)}
      buttons={[
        {
          children: 'Cancel',
          props: {
            backgroundColor: 'white',
            rounded: true,
            width: '100px',
            minWidth: '100px',
            marginRight: 'auto',
            onClick: () => hideModal(modalName),
          },
        },
        {
          children: 'Log Out',
          props: {
            primary: true,
            rounded: true,
            width: '200px',
            minWidth: '200px',
            onClick: () => {
              logout();
              hideModal(modalName);
            },
          },
        },
      ]}
    />
  );
};

export default LogoutModal;
